import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';
import FeaturesService from 'ember-feature-flags/services/features';

export default class TrialExpiredRoute extends Route {
  @service account!: AccountService;
  @service features!: FeaturesService;

  redirect() {
    // @todo: remove this feature flag after release
    if (!this.account.planFeatures.messaging.expired) {
      this.router.replaceWith('dashboard');
    }
  }
}
